import * as React from 'react';
const SvgTarget = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.998 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-5-1.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0m5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M1.996 9.997a8 8 0 1 1 15.998 0 8 8 0 0 1-15.998 0m8-6.5a6.5 6.5 0 1 0 0 12.999 6.5 6.5 0 0 0 0-12.998"
    />
  </svg>
);
export default SvgTarget;
